var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex mb-6 gap-2" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [
            _vm._v(" mdi-file-outline "),
          ]),
          _c("span", { staticClass: "text-xl font-medium text-primary" }, [
            _vm._v("ตั้งค่าเอกสาร"),
          ]),
        ],
        1
      ),
      _c("v-card", { staticClass: "rounded-lg p-5", attrs: { flat: "" } }, [
        _c(
          "div",
          { staticClass: "flex flex-col gap-3" },
          [
            _c(
              "div",
              { style: { maxWidth: "700px" } },
              [
                _c("select-form", {
                  staticClass: "tax-input-style",
                  attrs: {
                    text: _vm.$t("taxinvoice.vatRunningScope"),
                    state: _vm.state.vatRunningScope,
                    items: _vm.vatScope,
                    "item-text": "description",
                    "item-value": "name",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.submit("vatRunningScope")
                    },
                  },
                  model: {
                    value: _vm.setting.vatRunningScope,
                    callback: function ($$v) {
                      _vm.$set(_vm.setting, "vatRunningScope", $$v)
                    },
                    expression: "setting.vatRunningScope",
                  },
                }),
              ],
              1
            ),
            _c("toggle-form", {
              attrs: {
                text: _vm.$t("taxinvoice.defaultTaxInvoice"),
                state: _vm.state.defaultTaxInvoice,
              },
              on: {
                input: function ($event) {
                  return _vm.submit("defaultTaxInvoice")
                },
              },
              model: {
                value: _vm.setting.defaultTaxInvoice,
                callback: function ($$v) {
                  _vm.$set(_vm.setting, "defaultTaxInvoice", $$v)
                },
                expression: "setting.defaultTaxInvoice",
              },
            }),
            _c("toggle-form", {
              attrs: {
                text: _vm.$t("taxinvoice.vatExclude"),
                state: _vm.state.vatExclude,
              },
              on: {
                input: function ($event) {
                  return _vm.submit("vatExclude")
                },
              },
              model: {
                value: _vm.setting.vatExclude,
                callback: function ($$v) {
                  _vm.$set(_vm.setting, "vatExclude", $$v)
                },
                expression: "setting.vatExclude",
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }